




































import {Prop, Vue, Watch} from 'vue-property-decorator';
import Component from "vue-class-component";
import ToolTip from "@/components/ToolTip.vue";
import {QuotaLineConfig, QuotaLineWeek} from '@/types/QuotaLineConfig';
import {mapGetters} from 'vuex';

@Component({
  components: {
    ToolTip,
  },
  computed: {
    ...mapGetters([
      'getData',
      'totalQuotaString',
      'usedQuotaString',
      'tooltipContent',
      'finalUsedQuotaString',
    ]),
  },
})
export default class QuotaLine extends Vue {

  @Prop({
    type: Object,
    default: {
      mode: 'full',
      weekNumber: '01',
      year: '2020',
    }
  })
  public quotaLineConfig!: QuotaLineConfig;


  get weekNumber() {
    return this.quotaLineConfig.weekNumber + '-' + this.quotaLineConfig.year;
  }

  get lineChildWidth() {
    const data = this.$store.getters.getData(this.weekNumber);
    const usedQuota = data.usedQuota;
    if (usedQuota === -1) return 0;
    const initialFormQuota = data.initialFormQuota;
    const totalQuota = data.totalQuota;

    return (usedQuota - initialFormQuota) * 100 / totalQuota;
  }

  get lineAddedWidth() {
    const data = this.$store.getters.getData(this.weekNumber);
    const addedQuota = data.addedQuota
    const totalQuota = data.totalQuota;

    return addedQuota * 100 / totalQuota;
  }

  get lineOverflowCondition() {
    const data = this.$store.getters.getData(this.weekNumber);
    const usedQuota = data.usedQuota;
    const initialFormQuota = data.initialFormQuota;
    const totalQuota = data.totalQuota;
    const addedQuota = data.addedQuota

    return usedQuota - initialFormQuota + addedQuota > totalQuota;
  }

}

